module.exports = __webpack_public_path__ + "static/media/pool-hall14.dcf34596.jpg";